import type { TopicDataObject } from './service';

export type Topic = {
  description: string;
  id: string;
  name: string;
};

export const createTopic = (data: TopicDataObject): Topic => ({
  description: data.description,
  id: data.id,
  name: data.name,
});

export const createTopics = (data: TopicDataObject[]): Topic[] => data.map((topic) => createTopic(topic));
